import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { Check, ChevronRight } from 'lucide-react'
import { cn } from '../cn'
import { menuItem, menuLabel, menuSurface } from './menu-styles'

export const Menu = DropdownMenu.Root
export const MenuTrigger = DropdownMenu.Trigger
export const MenuSeparator = () => <DropdownMenu.Separator className="my-1 h-px bg-rule" />

export function MenuContent({ className, children, align = 'end' }: { className?: string; children: React.ReactNode; align?: 'start' | 'center' | 'end' }) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.Content align={align} sideOffset={4} className={cn(menuSurface, className)}>
        {children}
      </DropdownMenu.Content>
    </DropdownMenu.Portal>
  )
}

export function MenuItem({
  className,
  danger,
  ...props
}: React.ComponentProps<typeof DropdownMenu.Item> & { danger?: boolean }) {
  return <DropdownMenu.Item className={cn(menuItem, danger && 'text-danger', className)} {...props} />
}

export function MenuRadioItem({ className, children, ...props }: React.ComponentProps<typeof DropdownMenu.RadioItem>) {
  return (
    <DropdownMenu.RadioItem className={cn(menuItem, 'pl-7 relative', className)} {...props}>
      <DropdownMenu.ItemIndicator className="absolute left-2">
        <Check className="size-3.5" />
      </DropdownMenu.ItemIndicator>
      {children}
    </DropdownMenu.RadioItem>
  )
}

export const MenuRadioGroup = DropdownMenu.RadioGroup
export const MenuLabel = ({ className, ...props }: React.ComponentProps<typeof DropdownMenu.Label>) => (
  <DropdownMenu.Label className={cn(menuLabel, className)} {...props} />
)

/** Opens a nested menu off an item — e.g. "Projekt ▸" listing every project. */
export const MenuSub = DropdownMenu.Sub

export function MenuSubTrigger({ className, children, ...props }: React.ComponentProps<typeof DropdownMenu.SubTrigger>) {
  return (
    <DropdownMenu.SubTrigger className={cn(menuItem, 'justify-between', className)} {...props}>
      {children}
      <ChevronRight className="size-3.5 shrink-0 text-ink-faint" />
    </DropdownMenu.SubTrigger>
  )
}

export function MenuSubContent({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <DropdownMenu.Portal>
      <DropdownMenu.SubContent sideOffset={2} alignOffset={-4} className={cn(menuSurface, className)}>
        {children}
      </DropdownMenu.SubContent>
    </DropdownMenu.Portal>
  )
}
